export default "__VITE_ASSET__CiJFsVyZ__"